var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.846,
    y1: 0.847,
    x2: 0.154,
    y2: 0.153,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01d95a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00b248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b248"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58351",
    "data-name": "Group 58351",
    transform: "translate(-634 -315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42279",
    "data-name": "Path 42279",
    d: "M83.4,21.811C81.142,13.5,72.5,4.858,64.189,2.6A85.607,85.607,0,0,0,43,0,85.607,85.607,0,0,0,21.811,2.6C13.5,4.858,4.858,13.5,2.6,21.811A85.607,85.607,0,0,0,0,43,85.607,85.607,0,0,0,2.6,64.189C4.858,72.5,13.5,81.142,21.811,83.4A85.629,85.629,0,0,0,43,86a85.618,85.618,0,0,0,21.189-2.6C72.5,81.142,81.142,72.5,83.4,64.189A85.629,85.629,0,0,0,86,43,85.607,85.607,0,0,0,83.4,21.811Z",
    transform: "translate(634 315)",
    fill: "#00b248",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42280",
    "data-name": "Path 42280",
    d: "M140.639,109.131q-1.775-1.727-3.559-3.465-.05-2.414-.126-4.831a8.9,8.9,0,0,0-8.417-8.4q-2.422-.076-4.841-.126-1.75-1.774-3.465-3.549a7.752,7.752,0,0,0-11.35,0q-1.717,1.777-3.472,3.558-2.419.047-4.838.124a8.911,8.911,0,0,0-8.417,8.4q-.076,2.414-.126,4.831-1.782,1.742-3.559,3.462a7.729,7.729,0,0,0,0,11.326q1.777,1.718,3.559,3.458.05,2.419.126,4.836a8.895,8.895,0,0,0,8.417,8.4q2.422.076,4.841.126,1.752,1.777,3.465,3.551a7.76,7.76,0,0,0,11.355,0q1.723-1.772,3.469-3.553,2.419-.049,4.838-.124a8.914,8.914,0,0,0,8.417-8.4q.076-2.414.126-4.829,1.782-1.74,3.559-3.469a7.727,7.727,0,0,0,0-11.326Z",
    transform: "translate(562.445 243.205)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42281",
    "data-name": "Path 42281",
    d: "M183.737,196.531c-3.1,3.225-6.257,6.523-9.358,9.794a2.7,2.7,0,0,1-1.96.846h-.01a2.752,2.752,0,0,1-1.963-.843c-1.657-1.711-3.326-3.421-4.985-5.117a2.684,2.684,0,0,1,.055-3.841,2.757,2.757,0,0,1,3.883.049q1.486,1.524,2.978,3.057c2.462-2.579,4.935-5.173,7.369-7.73a2.736,2.736,0,0,1,3.867-.056A2.694,2.694,0,0,1,183.737,196.531Z",
    transform: "translate(502.427 158.456)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginTick);
export default __webpack_public_path__ + "static/media/LoginTick.67c8f801b58ee9368e5c83d67d0536b4.svg";
export { ForwardRef as ReactComponent };